import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ApiService } from './api.service';
// import { Agency } from '../models';

@Injectable()
export class CommonService {
  constructor (
    private apiService: ApiService
  ) {}

  fetchStates() {
    return this.apiService.getRawJson('states.json')
      .map(res => res);
  }

  fetchCities(state: string) {
    return this.apiService.getRawJson(`${state}.json`)
      .map(res =>  res);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts